import { create } from "zustand";
import { devtools } from "zustand/middleware";

/**
 * Zustand store for managing filter state across the application
 * IMPORTANT: Filters persist ONLY in runtime memory (not localStorage)
 * - Manual page refresh will reset filters to initial state
 * - Filters are retained during auto-refresh after CRUD operations
 * - URL query params can be used to share filter states (optional)
 */
const filterStore = (set, get) => ({
  // Invoice filters (ManageInvoice.jsx)
  invoiceFilters: {
    client: "",
    branch_name: "",
    lan: "",
    customer_name: "",
    is_paid: "",
    invoice_number: "",
    status: "",
    invoice_date: "",
    invoice_date_from: "",
    invoice_date_to: "",
  },

  // Assignment filters (ManageAssignments.jsx)
  assignmentFilters: {
    client_id: "",
    branch_name: "",
    invoice_number: "",
    lan_number: "",
    customer_name: "",
    assignment_from_date: "",
    assignment_to_date: "",
    assignment_type: "",
  },

  // Set invoice filters
  setInvoiceFilters: (filters) =>
    set(() => ({
      invoiceFilters: filters,
    })),

  // Set assignment filters
  setAssignmentFilters: (filters) =>
    set(() => ({
      assignmentFilters: filters,
    })),

  // Clear invoice filters
  clearInvoiceFilters: () =>
    set(() => ({
      invoiceFilters: {
        client: "",
        branch_name: "",
        lan_number: "",
        customer_name: "",
        is_paid: "",
        invoice_number: "",
        status: "",
        invoice_date: "",
        invoice_date_from: "",
        invoice_date_to: "",
      },
    })),

  // Clear assignment filters
  clearAssignmentFilters: () =>
    set(() => ({
      assignmentFilters: {
        client_id: "",
        branch_name: "",
        invoice_number: "",
        lan_number: "",
        customer_name: "",
        assignment_from_date: "",
        assignment_to_date: "",
        assignment_type: "",
      },
    })),

  // Update single invoice filter
  updateInvoiceFilter: (key, value) =>
    set((state) => ({
      invoiceFilters: {
        ...state.invoiceFilters,
        [key]: value,
      },
    })),

  // Update single assignment filter
  updateAssignmentFilter: (key, value) =>
    set((state) => ({
      assignmentFilters: {
        ...state.assignmentFilters,
        [key]: value,
      },
    })),

  // Get invoice filters
  getInvoiceFilters: () => get().invoiceFilters,

  // Get assignment filters
  getAssignmentFilters: () => get().assignmentFilters,
});

const useFilterStore = create(
  devtools(filterStore)
);

export default useFilterStore;
